export default __webpack_public_path__ + "static/media/london.368a0df4.jpg";